import {FC, ReactNode, useState} from 'react'
import {ChevronDownIcon} from '@/components/ui/icon/Icon'
import {Badge} from '@/components/ui/badge/Badge'
import {
    StyledCollapsibleSection,
    StyledCollapsibleHeader,
    StyledCollapsibleHeaderLeft,
    StyledChevron,
    StyledCollapsibleBody
} from './style'

interface MailerCollapsibleSectionProps {
    title: string
    activeCount: number
    activeCountLabel: string
    defaultOpen?: boolean
    children: ReactNode
}

export const MailerCollapsibleSection: FC<MailerCollapsibleSectionProps> = ({
    title,
    activeCount,
    activeCountLabel,
    defaultOpen = false,
    children
}) => {
    const [open, setOpen] = useState(defaultOpen)

    return (
        <StyledCollapsibleSection>
            <StyledCollapsibleHeader type="button" onClick={() => setOpen(prev => !prev)} aria-expanded={open}>
                <StyledCollapsibleHeaderLeft>
                    <span>{title}</span>
                    {activeCount > 0 && <Badge variant="primary">{activeCountLabel}</Badge>}
                </StyledCollapsibleHeaderLeft>
                <StyledChevron $open={open}>
                    <ChevronDownIcon size={16} />
                </StyledChevron>
            </StyledCollapsibleHeader>
            {open && <StyledCollapsibleBody>{children}</StyledCollapsibleBody>}
        </StyledCollapsibleSection>
    )
}
